import React from "react";
import PropTypes from "prop-types";

/**
 * Miniature app preview. All colors come straight from the theme's
 * CSS custom properties: main.scss scopes every theme block to
 * [data-theme="<id>"] (and the dark overlay to [data-mode="dark"]),
 * so setting those attributes here makes the real tokens cascade —
 * previews can never drift from the actual palette.
 */
const ThemePreviewMock = ({ themeId, isDark }) => (
  <div
    className="m-theme-selector__mock"
    data-theme={themeId}
    data-mode={isDark ? "dark" : undefined}
    aria-hidden="true"
  >
    <div className="m-theme-selector__mock-header">
      <span className="m-theme-selector__mock-dot" />
      <span className="m-theme-selector__mock-search" />
    </div>
    <div className="m-theme-selector__mock-body">
      <div className="m-theme-selector__mock-sidebar">
        <span className="m-theme-selector__mock-nav m-theme-selector__mock-nav--active" />
        <span className="m-theme-selector__mock-nav" />
        <span className="m-theme-selector__mock-nav" />
        <span className="m-theme-selector__mock-nav" />
      </div>
      <div className="m-theme-selector__mock-content">
        <span className="m-theme-selector__mock-title" />
        <span className="m-theme-selector__mock-row" />
        <span className="m-theme-selector__mock-row m-theme-selector__mock-row--ghost" />
        <span className="m-theme-selector__mock-row m-theme-selector__mock-row--ghost" />
        <div className="m-theme-selector__mock-actions">
          <span className="m-theme-selector__mock-btn" />
          <span className="m-theme-selector__mock-btn m-theme-selector__mock-btn--outline" />
        </div>
      </div>
    </div>
  </div>
);

ThemePreviewMock.propTypes = {
  themeId: PropTypes.string.isRequired,
  isDark: PropTypes.bool,
};

export default ThemePreviewMock;
